// extracted by mini-css-extract-plugin
export default {"question-group-scroll-container":"QuestionList_question-group-scroll-container__4D2nm","question-group-container":"QuestionList_question-group-container__APSXU"};